// eve's client calls Promise.withResolvers (ES2024), which Chrome < 119 and
// Safari < 17.4 lack. Imported first in main.js so it runs before any eve chunk.
if (typeof Promise.withResolvers !== "function") {
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new this((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
